import { configureStore } from '@reduxjs/toolkit';
import devicesSlice from './devicesSlice';
import themeSlice from './themeSlice';

const store = configureStore({
  reducer: {
    devices: devicesSlice,
    theme: themeSlice,
  },
});

export default store;
